import { RevisionIssueScanState } from '../../../types';
import type { Revision } from '../../../types';

const getCommitStatus = (revision: Revision): RevisionIssueScanState => {
  if (revision && revision.resolved) {
    const isScanProvided = revision.meta ? !!revision.meta[0] : true;
    if (isScanProvided) {
      // if a scan was submitted (manually or automatically), prefer Passing/Failing state over NeedsConfiguration
      const unresolvedIssueCount = revision.unresolved_issue_count ?? 0;
      return unresolvedIssueCount > 0 ? RevisionIssueScanState.IssuesFound : RevisionIssueScanState.Passing;
    }
    if (revision.error || revision.unsupported) {
      return RevisionIssueScanState.NeedsConfiguration;
    }
  }
  return RevisionIssueScanState.Waiting;
};

export default getCommitStatus;
